import React, { useEffect } from "react";
import { usePagination } from "react-instantsearch-hooks";
import PaginationNumeric from "@/components/PaginationNumeric.jsx";

const MasterMenuPagination = ({ resetKey }) => {
  const {
    currentRefinement,
    nbPages,
    isFirstPage,
    isLastPage,
    refine,
  } = usePagination();

  useEffect(() => {
    refine?.(0);
  }, [resetKey, refine]);

  if (nbPages <= 1) {
    return null;
  }

  return (
    <div className="mb-4 px-5">
      <PaginationNumeric
        currentPage={currentRefinement}
        onSelect={refine}
        totalPages={nbPages}
        isFirstPage={isFirstPage}
        isLastPage={isLastPage}
      />
    </div>
  );
};

export default MasterMenuPagination;
